<template>
    <div class="shortmessageindex">
        <div class="top">
            <el-col :span="19">
               <el-button type="primary" size="medium" @click="shortmessagewholelist()">充值记录总表</el-button>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入学校名称" v-model.trim="listQuery.schoolName" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
             <el-table-column  label="学校名称" show-overflow-tooltip  >
                <template slot-scope="scope">
                    <span class="link-type" @click="shortmessagelist(scope.row.schoolId)"> {{scope.row.schoolName}}</span>
                </template>
            </el-table-column>
             <el-table-column label="短信总量（条）" align="center">
                <template slot-scope="scope">
                        {{scope.row.totalCount?scope.row.totalCount:0}}
                </template>
            </el-table-column>
            <el-table-column label="已使用（条）" align="center">
                <template slot-scope="scope">
                        {{scope.row.usedCount?scope.row.usedCount:0}}
                </template>
            </el-table-column>
            <el-table-column label="短信余量（条）" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.totalCount-scope.row.usedCount}}
                </template>
            </el-table-column>
              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="remindSchoolManagers(scope.row.schoolId)"  type="text" size="small">充值提醒</el-button>
                         <el-button  @click.native.prevent="shortmessageadd(scope.row.schoolId,scope.row.schoolName)"  type="text" size="small">充值</el-button>
                    </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {statisticGroupBySchoolId,remindSchoolManager} from '@/api/shortmessage';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    schoolName: ''
                },
                dataList: [],
                total: null
            }
        },
        created() {
            this.queryFoodLists();
        },
        mixins: [mixin],
        methods: {
            remindSchoolManagers(id){
               this.$confirm('是否充值提醒?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    remindSchoolManager(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '充值提醒成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },
            //获取列表
            queryFoodLists() {
                statisticGroupBySchoolId(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            },
            //切换码数
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            //学校
            shortmessagelist(schoolId){
                this.$router.push({
                    path: "shortmessagelist",
                    query:{
                        schoolId:schoolId
                    }
                });
            },
            //充值
            shortmessageadd(schoolId,schoolName){
                this.$router.push({
                    path: "shortmessageadd",
                     query:{
                        schoolId:schoolId,schoolName:schoolName
                    }
                });
            },
            shortmessagewholelist(){
                this.$router.push({
                    path: "shortmessagewholelist"
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
.shortmessageindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
    .top-box{
        width: 100%;
        height: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/shortmessage/shortmessageindex.vue